"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function XLogoIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { fill: "none", width: "24", height: "24" }),
        react_1.default.createElement("path", { d: "m13.758,10.56l6.892-8.062h-1.633l-5.984,7-4.779-7H2.742l7.227,10.586-7.227,8.454h1.633l6.319-7.393,5.047,7.393h5.512l-7.494-10.978h0,0Zm-2.237,2.617l-.732-1.054L4.963,3.735h2.509l4.702,6.769.732,1.054,6.112,8.798h-2.508l-4.988-7.18h0s0,0,0,0Z" })));
}
exports.default = XLogoIcon;
